import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import CONFIG from '../config'
import { AuthenticationService } from './authentication.service'
import { Platform } from '@ionic/angular';
import { HTTP } from '@ionic-native/http/ngx'
import { from } from 'rxjs';
import enviarToken from '../iterceptorNative';

@Injectable({
  providedIn: 'root'
})
export class XmlService {

  constructor(public httpNative: HTTP, public http: HttpClient, public platform: Platform) { }

  obtenerXMLNoEnviados(id){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/xml/'+id, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/xml/'+id)
          .subscribe((xml: any) => {
            resolve(xml)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  
  reenviarXML(datos){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.put(CONFIG.API + '/api/xml/'+datos.idReporte+'/'+datos.idXML, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.put(CONFIG.API + '/api/xml/'+datos.idReporte+'/'+datos.idXML,{})
          .subscribe((xml: any) => {
            resolve(xml)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  guardarFicha(datos){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/xml/fichaAdicional/', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/xml/fichaAdicional',datos)
          .subscribe((xml: any) => {
            resolve(xml)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
}
